// @mui
import { enUS, svSE } from '@mui/material/locale';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    icon: '/assets/icons/flags/ic_flag_se.svg',
    label: 'Swedish',
    systemValue: svSE,
    value: 'sv-SE',
  },
  {
    icon: '/assets/icons/flags/ic_flag_en.svg',
    label: 'English',
    systemValue: enUS,
    value: 'en',
  },
];

export const defaultLang = allLangs[0]; // English
